import { PropTypes } from "prop-types"

import Input from "../Input"

export const InputPassword = props => (
  <Input className="oj-input-password" type="password" {...props} />
)

InputPassword.propTypes = {
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  placeholder: PropTypes.string.isRequired
}

export default InputPassword
